import SplitType from 'split-type'
import { bp, mm, sel, selAll, stLineWrap } from './utils'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default function Insight(container) {
  const ctx = gsap.context(() => {
    // document.body.parentNode.style.scrollBehavior = 'auto'
    // document.body.parentNode.style.setProperty('scroll-behavior', 'auto', 'important')
    // document.body.style.setProperty('scroll-behavior', 'auto', 'important')
    // document.body.style.opacity = '1'
    // console.log('Insight component loaded')

    const sel = (el) => container.querySelector(el)
    const selAll = (el) => container.querySelectorAll(el)
    // sel('html').style.scrollBehavior = 'auto !important'
    const header$a = selAll('.insight-rt__header>*')
    const rtW$ = sel('.insight-rt__rt-w')
    // let sidebarItem$a = []
    setTimeout(() => {
      // const titleHight = sel('.insight-rt__header').getBoundingClientRect().height
      // const sidebar$ = sel('.insight-rt__sidebar')
      // mm.add(bp.tabUp, () => {
      //   sidebar$.style.top = `calc(${titleHight}px + 4.5rem + var(--size--gap))`
      // })

      const sidebarToc$ = sel('.fs-toc_link-content')
      const sidebarItemsNum = sidebarToc$.querySelectorAll('.fs-toc_link-wrapper.is-h2').length
      if (sidebarItemsNum <= 1) {
        const sidebarW$ = sel('.insight-rt__sidebar-w')
        sidebarW$.classList.add('hide')
      }
      console.log('sidebarItemsNum', sidebarItemsNum)
      setTimeout(() => {
        const sidebarTocLastH2$ = sidebarToc$.querySelector(':nth-last-child(1 of .fs-toc_link-wrapper.is-h2)')
        console.log(sidebarTocLastH2$)
        sidebarToc$.style.setProperty('--line-height', sidebarTocLastH2$ ? `calc(100% - ${sidebarTocLastH2$.getBoundingClientRect().height}px)` : '2.5rem')
      }, 100)
      const sidebarCorner$a = selAll('.toc__link__line')
      // console.log('sidebarItem$a', sidebarItem$a)
      const sidebarItem$a = selAll('[fs-toc-element="link"]')
      // console.log('Webflow tabs redraw')
      const tocTl = gsap.timeline()
      tocTl
        .from(sidebarItem$a, {
          x: 10,
          autoAlpha: 0,
          duration: 1.5,
          stagger: {
            amount: 0.2,
          },
          ease: 'power4.out',
          delay: 0.5,
        })
        .from(
          sidebarCorner$a,
          {
            x: 10,
            autoAlpha: 0,
            duration: 1.5,
            stagger: {
              amount: 0.2,
            },
            ease: 'power4.out',
          },
          '<'
        )
        .from(sidebarToc$, { '--line-color': 'transparent' }, '<+.2')
    }, 500)
    const sidebarH$ = sel('.insight-rt__sidebar__h')

    const heroTl = gsap
      .timeline({ defaults: { ease: 'power4.out' } })
      .from(header$a, { x: 20, opacity: 0, duration: 1.5, stagger: 0.25 }, 0)
      .from(rtW$, { y: 10, opacity: 0, duration: 1.5 }, 0.4)
      .from(sidebarH$, { x: 10, opacity: 0, duration: 1.5 }, '>-1')

    mm.add(bp.landDown, () => {
      const sidebarW$ = sel('.insight-rt__sidebar-w')
      const sidebarHW$ = sel('.insight-rt__sidebar__h-w')
      const sidebar$ = sel('.insight-rt__sidebar')
      const sidebarC$ = sel('.insight-rt__sidebar__c')
      const sidebarToc$ = sel('.insight-rt__sidebar__toc-w')
      console.log(sidebarToc$)
      const rt$ = sel('.insight-rt__rt-w:not(.hide')
      const sidebarSvg$ = sel('.insight-rt__sidebar__svg-w')

      sidebarHW$.setAttribute('data-close', '-1')

      setTimeout(() => {
        ScrollTrigger.create({
          trigger: sidebarW$,
          start: 'top top+=64',
          endTrigger: rt$,
          end: 'bottom top+=128',
          // end: '+=5000',
          pin: sidebar$,
          pinSpacing: false,
        })
        ScrollTrigger.create({
          trigger: sidebarW$,
          start: 'top top+=64',
          endTrigger: rt$,
          end: 'top top+=128',
          scrub: true,
          animation: gsap.to(sidebarToc$, {
            height: 0,
            ease: 'none',
            onComplete: () => {
              sidebarHW$.setAttribute('data-close', '1')
            },
            onReverseComplete: () => {
              sidebarHW$.setAttribute('data-close', '-1')
            },
          }),
        })
        const tocTlOpts = { ease: 'power4.out', duration: 0.5 }
        ;[sidebarHW$].forEach((el) => {
          el.addEventListener('click', () => {
            toggleToc()
          })
        })
        document.addEventListener('scroll', (event) => {
          if (sidebarHW$.getAttribute('data-close') === '0') {
            closeToc()
          }
        })
        function toggleToc() {
          if (sidebarHW$.getAttribute('data-close') === '0') {
            closeToc()
          } else if (sidebarHW$.getAttribute('data-close') === '1') {
            openToc()
          }
        }

        function openToc() {
          gsap.to(sidebarToc$, { height: 'auto', ...tocTlOpts })
          gsap.to(sidebarSvg$, { rotate: -90, ...tocTlOpts })
          sidebarHW$.setAttribute('data-close', '0')
        }
        function closeToc() {
          gsap.to(sidebarToc$, { height: 0, ...tocTlOpts })
          gsap.to(sidebarSvg$, { rotate: 0, ...tocTlOpts })
          sidebarHW$.setAttribute('data-close', '1')
        }
      }, 500)
    })

    const shareA$ = sel('.insight-rt__share__a')
    if (shareA$) {
      const shareAP$ = sel('.insight-rt__share__p')
      const shareAsvg$ = sel('.insight-rt__share__svg')
      // console.log('Share link element found:', shareA$, shareAP$, shareAsvg$)

      shareA$.addEventListener('click', async (e) => {
        e.preventDefault()
        try {
          await navigator.clipboard.writeText(window.location.href)
          shareAsvg$?.remove()
          shareAP$?.classList.remove('hide')
        } catch (err) {
          console.error('Failed to copy URL:', err)
        }
      })
    }
  })
  return ctx
}
